import {useCookies} from 'react-cookie';
export const ProtectedRoute = ({children}: ProtectedRouteProps) => {
  const [cookie] = useCookies(['access_token']);
  const user = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user') || '')
    : null;
  if (cookie) {
    if (cookie.access_token) {
      if (user) {
        return children;
      } else {
        localStorage.setItem('user', JSON.stringify(cookie.access_token));
        return children;
      }
    } else {
      window.location.replace('https://app.beta.mazraeapp.com/home');
    }
  }
  window.location.replace('https://app.beta.mazraeapp.com/home');
  return null;
};
